import React, { useEffect, useRef, useState } from "react";
import { HiOutlineMail } from "react-icons/hi";
import { LuTwitter } from "react-icons/lu";
import { TiSocialLinkedin } from "react-icons/ti";
import styled from "styled-components";
import "./app.css";
import "./assets/SuperCool.ttf";
// @ts-ignore
import Globe from "react-globe.gl";

import { RowDiv } from "../components/Layout";
import { H2 } from "../components/Typography";
import useWindowDimensions from "../hooks/useWindowDimensions";

interface Props {}

const Home: React.FC<Props> = () => {
  const [savedToClipboard, setSavedToClipboard] = useState(false);
  const { size } = useWindowDimensions();
  const globeEl = useRef();

  useEffect(() => {
    if (savedToClipboard)
      setTimeout(() => {
        setSavedToClipboard(false);
      }, 1000);
  }, [savedToClipboard]);

  useEffect(() => {
    // Auto-rotate the globe
    if (globeEl.current) {
      // @ts-ignore
      globeEl.current.controls().autoRotate = true;
      // @ts-ignore
      globeEl.current.controls().autoRotateSpeed = 0.5;
    }
  }, []);

  const saveToClipboard = () => {
    navigator.clipboard.writeText("daniel@friedebold.net");
    setSavedToClipboard(true);
  };

  return (
    <Background>
      <GlobeContainer>
        <Globe
          ref={globeEl}
          globeImageUrl="//upload.wikimedia.org/wikipedia/commons/thumb/9/91/Land_shallow_topo_2048.jpg/1920px-Land_shallow_topo_2048.jpg"
          backgroundColor="rgba(0,0,0,0)"
          atmosphereColor="rgba(109, 129, 189, 0.1)"
          atmosphereAltitude={0.25}
          width={typeof window !== "undefined" ? window.innerWidth : 800}
          height={typeof window !== "undefined" ? window.innerHeight : 600}
        />
      </GlobeContainer>
      <ContentOverlay>
        <H2 style={{ fontFamily: "Inter", fontSize: 24, fontWeight: 400 }}>
          Daniel Friedebold
        </H2>
        <RowDiv
          style={{
            gap: 10,
            margin: 20,
            marginTop: 0,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <ContactButton onClick={() => saveToClipboard()}>
            {!savedToClipboard ? (
              <HiOutlineMail />
            ) : (
              <p>copied to clipboard...</p>
            )}
          </ContactButton>
          <a target="none" href={"https://www.linkedin.com/in/friedebold/"}>
            <ContactButton>
              <TiSocialLinkedin />
            </ContactButton>
          </a>
          <a target="none" href={"https://x.com/friedebold/"}>
            <ContactButton>
              <LuTwitter />
            </ContactButton>
          </a>
        </RowDiv>
      </ContentOverlay>
    </Background>
  );
};

const Background = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: black;
  align-items: center;
  justify-content: center;
  gap: 32px;
  position: relative;
  overflow: hidden;
`;

const GlobeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const ContentOverlay = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const ContactButton = styled.div`
  border: 1px solid rgba(236, 216, 174, 0.2);
  padding: 10px 10px;
  border-radius: 0px;
  text-decoration: none;
  color: #d8d8d8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  border-radius: 10px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
export default Home;
